"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _getCdnProps = _interopRequireDefault(require("./getCdnProps"));
var _getNamespace = _interopRequireDefault(require("./getNamespace"));
var _loadComponent = _interopRequireDefault(require("./loadComponent"));
var _loadConfig = _interopRequireDefault(require("./loadConfig"));
var _loadDependencies = _interopRequireDefault(require("./loadDependencies"));
var _loadI18n = _interopRequireDefault(require("./loadI18n"));
var _default = exports.default = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(props) {
    var appConfig, cdnProps, _yield$Promise$all, _yield$Promise$all2, i18nContent, nsData;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          (0, _loadDependencies.default)(props);
          _context.next = 3;
          return (0, _loadConfig.default)(props);
        case 3:
          appConfig = _context.sent;
          cdnProps = (0, _getCdnProps.default)(props, appConfig);
          _context.next = 7;
          return Promise.all([(0, _loadI18n.default)(props, appConfig, cdnProps), (0, _loadComponent.default)(props, cdnProps)]);
        case 7:
          _yield$Promise$all = _context.sent;
          _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 1);
          i18nContent = _yield$Promise$all2[0];
          nsData = (0, _getNamespace.default)(props.namespace);
          nsData.scriptLoaded = true;
          return _context.abrupt("return", {
            appConfig: appConfig,
            i18nContent: i18nContent,
            scriptLoaded: true
          });
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();